import EchoClient from 'laravel-echo'
import Pusher from 'pusher-js'
import { ref, watch, onUnmounted, onBeforeMount } from 'vue'

const isDev = process.env.NODE_ENV === 'development'

window.Pusher = Pusher
// window.Pusher.logToConsole = isDev

const pusherOptions = {
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: !isDev
}

const echoClient = new EchoClient({
  broadcaster: 'pusher',
  ...pusherOptions
})

export const PUSHER_CONNECTION_STATES = {
  UNAVAILABLE: 'unavailable',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting'
}

const pusherConnectionState = ref(PUSHER_CONNECTION_STATES.DISCONNECTED)

const trackPusherConnectionState = () => {
  echoClient.connector.pusher.connection.bind('state_change', function (states) {
    console.info('Websocket connection state changed from ' + states.previous + ' to ' + states.current)
    pusherConnectionState.value = states.current
  })
}

trackPusherConnectionState()

let subscribers = ref(0)
let hangupSignal = null

watch(subscribers, (curSubscribers, prevSubscribers) => {
  if (curSubscribers === 0) {
    hangupSignal = setTimeout(() => {
      echoClient.disconnect()
    }, 500)
  } else if (curSubscribers > 0 && prevSubscribers === 0) {
    if (hangupSignal) {
      clearTimeout(hangupSignal)
    }
    if (echoClient.connector.pusher.connection.state === 'disconnected') {
      echoClient.connect()
      // Diconecting and reconnecting will create a new pusher instance.
      // re-bind the pusher connection state listener.
      trackPusherConnectionState()
    }
  }
})

export const useEcho = () => {
  onBeforeMount(() => {
    subscribers.value++
  })

  onUnmounted(() => {
    subscribers.value--
  })

  return { echoClient, pusherConnectionState }
}

const ECHO_CHANNELS = {
  TEST: 'test.channel',
  FULFILLMENTS: (companyId) => `fulfillments.${companyId}`,
  SCAN_RECORDS: (locationId) => `scan-records.${locationId}`
}

export const createChannel = (type, ...args) => {
  switch (type) {
    case 'fulfillments':
      return ECHO_CHANNELS.FULFILLMENTS(...args)
    case 'scanRecords':
      return ECHO_CHANNELS.SCAN_RECORDS(...args)
    case 'test':
      return ECHO_CHANNELS.TEST
    default:
      throw new Error(`Unknown channel type: ${type}`)
  }
}

export const ECHO_EVENTS = {
  ORDER_LOCK_CHANGED: '.order.lock-changed',
  ORDER_FULFILLMENT_UPDATED: '.order.fulfillment-updated',
  SCAN_RECORD_CREATED: '.scan-record.created'
}
